import {
    Component,
    OnInit,
    OnDestroy,
    Output,
    EventEmitter,
} from '@angular/core';
import {BaseClass} from 'src/app/shared/classes/base';
import {
    ToastController,
} from '@ionic/angular';
import {TranslationService} from 'src/app/shared/services/translation.service';
import {FeedbackService} from 'src/app/feedback/feedback.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-feedback-status',
    templateUrl: './feedback-status.component.html',
    styleUrls: ['./feedback-status.component.scss'],
})
export class FeedbackStatusComponent extends BaseClass
    implements OnDestroy, OnInit {
    @Output() reloadProgresses: EventEmitter<boolean> = new EventEmitter();
    public principles = [];
    public goodPrinciples = [];
    public badPrinciples = [];
    public unreadCount = 0;
    public enabled = false;
    private _selectedLanguage: string = '';
    public Math = Math;

    constructor(
        _toastController: ToastController,
        _translationService: TranslationService,
        private _router: Router,
        private _feedbackService: FeedbackService
    ) {
        super(_toastController, _translationService);
    }

    ngOnInit() {
        this._selectedLanguage = this._translationService.getSelectedLanguage();
        this.getFeedback();
    }

    getFeedback() {
        this._feedbackService.getFeedbackDashboard().subscribe(
            (res) => {
                this.enabled = res.data.enabled;
                this.principles = res.data.principles;
                this.goodPrinciples = this.getGoodPrinciples();
                this.badPrinciples = this.getBadPrinciples();
                this.unreadCount = res.data.unreadCount;
            },
            (error) => {
                console.error(error);
            }
        );
    }

    getBadPrinciples() {
        const returnPrinciples = [];
        for (let i = 0; i < this.principles.length; i++) {
            const principle = this.principles[i];
            if (principle.sum > 3.5) {
                break;
            } else {
                returnPrinciples.push(principle);
            }
        }
        return returnPrinciples.sort((a, b) => b.sum - a.sum);
    }

    getGoodPrinciples() {
        const returnPrinciples = [];
        for (let i = this.principles.length - 1; i > -1; i--) {
            const principle = this.principles[i];
            if (principle.sum <= 3.5) {
                break;
            }
            returnPrinciples.push(principle);
        }
        return returnPrinciples.sort((a, b) => b.sum - a.sum);
    }

    public getPrincipleText(principle: any) {
        return principle[this._selectedLanguage];
    }

    public goToFeedbacks(): void {
        this._router.navigate(['/feedback/user']);
    }

    ngOnDestroy() {
    }
}
